import React from 'react'

import type { MenuContentBlock } from '@library/api-menu-experience'

import { renderContentBlocks } from './renderContentBlocks'

type CollectionScreenWrapperProps = {
  contentBlocks: MenuContentBlock[]
  collectionId?: string
}

export const CollectionScreenWrapper = ({
  contentBlocks,
  collectionId,
}: CollectionScreenWrapperProps) => (
  <div data-testid="menu-experience-collection-screen">
    {renderContentBlocks(contentBlocks, { collectionId })}
  </div>
)
